import _ from 'underscore'
import {createSelector} from 'reselect'

const getWorkScheduleStateCommon = state => state.workSchedule

const getWorkScheduleState = createSelector(
    getWorkScheduleStateCommon,
    commonState => commonState.page
)

export const isLoading = createSelector(
    getWorkScheduleState,
    (workScheduleState) => workScheduleState.loading
)

export const getEditingDays = createSelector(
    getWorkScheduleState,
    (workScheduleState) => workScheduleState.editingDays
)

export const isEditing = createSelector(
    getEditingDays,
    (editingDays) => _.size(editingDays) > 0
)

export const isFirstLoading = createSelector(
    getWorkScheduleState,
    (workScheduleState) => workScheduleState.firstLoading
)

export const geSelectedYear = createSelector(
    getWorkScheduleState,
    (workScheduleState) => workScheduleState.selectedYear
)

export const getDefaultWorkSchedule = createSelector(
    getWorkScheduleState,
    (workScheduleState) => workScheduleState.defaultWorkSchedules
)

export const getCorporateDays = createSelector(
    getWorkScheduleState,
    (workScheduleState) => workScheduleState.corporateDays
)

export const getCorporateDaysForSelectedYear = createSelector(
    getCorporateDays,
    geSelectedYear,
    (corporateDays, year) => corporateDays[year]
)

export const getLeaveBlackoutDays = createSelector(
    getWorkScheduleState,
    (workScheduleState) => workScheduleState.leaveBlackoutDays
)

export const getLeaveBlackoutDaysForSelectedYear = createSelector(
    getLeaveBlackoutDays,
    geSelectedYear,
    (leaveBlackoutDays, year) => leaveBlackoutDays[year]
)

export const getDefaultTimeZoneCountry = createSelector(
    getWorkScheduleState,
    workScheduleState => workScheduleState.defaultTimeZoneCountry
)

export const getCountries = createSelector(
    getWorkScheduleState,
    workScheduleState => workScheduleState.countries
)

export const isLoadingCountries = createSelector(
    getWorkScheduleState,
    workScheduleState => workScheduleState.loadingCountries
)



// WEBPACK FOOTER //
// ./web/js/administration/workSchedule/selectors.js